import lodash from 'lodash';
import { binderInstitutionIdSelector, userDefaultInstitutionIdSelector } from 'common/selectors';

export const canAccessSystemPermissionWithinBinderPredicate = (state, systemPermissionKey) => {
    const institutionId = binderInstitutionIdSelector(state);
    const institutionPermission = lodash.get(state, `me.institutionPermissions.${institutionId}.${systemPermissionKey}`, false);
    return institutionPermission;
};

export const canAccessSystemPermissionPredicate = (state, systemPermissionKey) => {
    const institutionId = userDefaultInstitutionIdSelector(state);
    const institutionPermission = lodash.get(state, `me.institutionPermissions.${institutionId}.${systemPermissionKey}`, false);
    return institutionPermission;
};


export const isAuthenticated = me => !lodash.isEmpty(me);
/**
 * For complion 4.0 this is considered as legacy binder predicate
 * @param {*} state 
 * @returns Bolean
 */
export const createBinderPredicate = (state) => canAccessSystemPermissionPredicate(state, 'createBinder');
export const createStudyPredicate = (state) => canAccessSystemPermissionPredicate(state, 'createStudy');

/**
 * In complion 4.0 we are merging both createStudyPredicate and createBinderPredicate
 * @param {*} state 
 * @returns 
 */
export const createNewBinderPredicate = (state) => (createBinderPredicate(state) || createStudyPredicate(state));


export const manageStudyPermissionsPredicate = (state) => canAccessSystemPermissionPredicate(state, 'manageStudyPermissions');
export const canEditUsersPredicate = (state) => canAccessSystemPermissionPredicate(state, 'institutionalAdmin');
export const canEditGroupsPredicate = (state) => canAccessSystemPermissionPredicate(state, 'institutionalAdmin');
export const canAccessBinderTaskPredicate = (state) => canAccessSystemPermissionWithinBinderPredicate(state, 'manageTasks');
export const dataSourcesPredicate = (state) => canAccessSystemPermissionPredicate(state, 'dataSources');
export const reportPredicate = state => canAccessSystemPermissionPredicate(state, 'accessReport');
export const institutionalAdminPredicate = state => {
    return  canEditGroupsPredicate(state) ||
            canEditUsersPredicate(state) ||
            dataSourcesPredicate(state);
};

export const manageInternalUsersPredicate = binderPermissions => binderPermissions.manageInternalUserAccess;
export const manageExternalUsersPredicate = binderPermissions => binderPermissions.manageExternalUserAccess;
export const editBinderDetailsPredicate = binderPermissions => binderPermissions.editBinderDetails;
export const editBinderQueryPredicate = binderPermissions => binderPermissions.editBinderQuery;
export const timelinePredicate = binderPermissions => binderPermissions.timeline;
export const compilePredicate = binderPermissions => binderPermissions.compile;

export const unfiledDocumentsPredicate = binderPermissions => binderPermissions.unfiledDocuments;

export const manageInternalUsersMenuPredicate = ({binderPermissions, binder}) => binderPermissions.manageInternalUserAccess && binder.status !== 'NEW';
export const manageExternalUsersMenuPredicate = ({binderPermissions, binder}) => binderPermissions.manageExternalUserAccess && binder.status !== 'NEW';
export const editBinderDetailsMenuPredicate = ({binderPermissions, binder}) => binderPermissions.editBinderDetails || binderPermissions.viewBinderSetupDetails;
export const editBinderQueryMenuPredicate = ({binderPermissions, binder}) => binderPermissions.editBinderQuery || binderPermissions.viewBinderSetupDetails;
export const timelineMenuPredicate = ({binderPermissions, binder}) => binderPermissions.timeline && binder.status !== 'NEW';
export const compileMenuPredicate = ({binderPermissions, binder}) => binderPermissions.compile && binder.status !== 'NEW';

export const binderSetupTabPredicate = ({binderPermissions, binder}) => 
    binderPermissions.viewBinderSetupDetails 
    || binderPermissions.editBinderQuery 
    || binderPermissions.editBinderDetails 
    || binderPermissions.manageExternalUserAccess 
    || binderPermissions.manageInternalUserAccess;

export const defaultBinderSetupPath = ({binderPermissions, binderId}) => {
    if(binderPermissions.viewBinderSetupDetails || binderPermissions.editBinderDetails){
        return `/binder/${binderId}`;
    }
    if(binderPermissions.manageInternalUserAccess) {
        return `/binder/${binderId}/users`;
    }
    if(binderPermissions.manageExternalUserAccess) {
        return `/binder/${binderId}/externalUsers`;
    }
    if(binderPermissions.editBinderQuery){
        return `/binder/${binderId}/setup`;
    }
    return '/';
};

export const initialIndexPredicate = ({documentTypes}) => {
    return !lodash.isEmpty(documentTypes) && lodash.every(documentTypes, (dT) => dT.permissions.initialIndex === true);
};

// Change Document Attributes (Descriptos)
export const indexDocumentPredicate = ({documentTypes, loadingMe}) => {
    if (loadingMe) {
        return false;
    }
    return !lodash.isEmpty(documentTypes) && lodash.every(documentTypes, (dT) => dT.permissions.index === true);
};

export const reIndexDocumentPredicate = ({documentTypes, loadingMe}) => {
    if (loadingMe) {
        return false;
    }
    return !lodash.isEmpty(documentTypes) && lodash.every(documentTypes, (dT) => dT.permissions.reIndex === true);
};
